interface UserRoleIconComponentProps {
  primaryColor?: string;
  secondaryColor?: string;
  onClick?: (value: any) => void;
  style?: React.CSSProperties;

}

const UserRoleIconSVGComponent = ({ primaryColor, secondaryColor, onClick, style }: UserRoleIconComponentProps) => (

  <svg width={style?.width || 19} height={style?.height || 21} viewBox="0 0 19 21" fill="none" style={style ? style : undefined} onClick={onClick} xmlns="http://www.w3.org/2000/svg">
    <g id="Group">
      <path id="Vector" d="M9.29016 10.905C6.30016 10.905 3.87012 8.47495 3.87012 5.48495C3.87012 2.49495 6.30016 0.0649414 9.29016 0.0649414C12.2802 0.0649414 14.7102 2.49495 14.7102 5.48495C14.7102 8.47495 12.2702 10.905 9.29016 10.905ZM9.29016 1.19495C6.92016 1.19495 4.99011 3.12496 4.99011 5.49496C4.99011 7.86496 6.92016 9.79495 9.29016 9.79495C11.6602 9.79495 13.5902 7.86496 13.5902 5.49496C13.5802 3.11496 11.6602 1.19495 9.29016 1.19495Z" fill={primaryColor} />
      <path id="Vector_2" d="M18.5701 20.935H0V19.425C0 14.305 4.16003 10.145 9.28003 10.145C14.4 10.145 18.5601 14.305 18.5601 19.425V20.935H18.5701ZM1.12 19.815H17.4501V19.425C17.4501 14.925 13.79 11.265 9.29004 11.265C4.79004 11.265 1.13 14.925 1.13 19.425V19.815H1.12Z" fill={primaryColor} />
    </g>
  </svg>


);

export default UserRoleIconSVGComponent;
